import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UBXHeadingModule } from '../heading/heading.module';
import { UBXIconModule } from '../icon/icon.module';
import { UBXModalComponent } from './modal.component';
import { UBXModalBoxComponent } from './box/modal-box.component';

const Imports = [
    UBXHeadingModule,
    UBXIconModule,
];
const Module = [
    UBXModalComponent,
    UBXModalBoxComponent,
];

@NgModule({
    declarations: [
        Module
    ],
    imports: [
        CommonModule,
        Imports
    ],
    exports: [
        Module
    ],
})
export class UBXModalModule {}
